import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";
import { Pack } from "../../packs.types";

export const requestGetPack = async (packId: string): Promise<Pack> => {
  return await instance.get(buildUrl(ApiRoutesPacks.OnePack, packId));
};
